import React from 'react';
import { PageTitle, MainSectionPanel } from '../../components/common';

const ReportsPage: React.FC = () => {
  return (
    <MainSectionPanel>
      <PageTitle
        title="Reports"
        subtitle="Reportes y análisis del sistema"
      />
    </MainSectionPanel>
  );
};

export default ReportsPage;